import heroBanner from "../../assets/images/pages/florida-driving-test.jpg";
import trafficSchoolImg from "../../assets/images/pages/cursos-en-espanol/escuela-de-trafico.jpg";
import licenseImg from "../../assets/images/pages/cursos-en-espanol/licencia.jpg";
import drivingLessonsImg from "../../assets/images/pages/cursos-en-espanol/classes-de-manejo.jpg";
import duiImg from "../../assets/images/pages/cursos-en-espanol/dui-esp.jpg";

const CoursesInSpanish = () => {
    const lessonCards = [
        {
            title: "Curso para Multas",
            imgSrc: trafficSchoolImg,
            link: "/curso-para-multas",
            text: "Curso para multas",
        },
        {
            title: "Curso para Obtener la Licencia",
            imgSrc: licenseImg,
            link: "/curso-para-obtener-la-licencia",
            text: "Curso para obtener la licencia",
        },
        {
            title: "Clases de Manejo",
            imgSrc: drivingLessonsImg,
            link: "/clases-de-manejo",
            text: "Clases de manejo",
        },
        {
            title: "Curso de DUI",
            imgSrc: duiImg,
            link: "/dui-en-espanol",
            text: "Curso de DUI",
        },
    ];

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">Cursos en Español</h1>
                            <p className="banner-subheading">
                                <a href="tel:18884163876" className="text-white text-decoration-none">
                                    1-888-41-METRO
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container py-5">
                <div className="row">
                    <div className="col-12">
                        <div className="row g-4">
                            {lessonCards.map((card, index) => (
                                <div key={index} className="col-lg-4 col-md-6">
                                    <div className="card text-white border-0 rounded-lg overflow-hidden course-card">
                                        <img
                                            src={card.imgSrc}
                                            className="card-img"
                                            alt={card.title}
                                        />
                                        <div className="card-img-overlay card-img-overlay-custom d-flex flex-column justify-content-end p-4">
                                            <div>
                                                <h4 className="card-title fw-bold">{card.title}</h4>
                                                <a
                                                    href={card.link}
                                                    className="btn btn-light rounded-lg mt-3 px-4"
                                                    style={{
                                                        backgroundColor: "var(--metro-yellow)",
                                                        border: "none",
                                                    }}
                                                >
                                                    Más Información
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="text-center mt-5">
                            <p className="text-white fw-bold">
                                Llame (<a href="tel:1-888-41-63876" style={{ color: "var(--metro-yellow)", textDecoration: "none" }}>1-888-41-METRO</a>) para más información.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container" style={{ marginBottom: "32px" }}>
                <div className="row text-white">
                    <p>
                        Superb Customer Service
                    </p>
                    <p>
                        At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!
                    </p>
                </div>
            </div>
        </>
    );
};

export default CoursesInSpanish;
